import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import Swal from 'sweetalert2';

@Component({
  standalone: false,
  selector: 'app-recuperar',
  templateUrl: './recuperar.component.html',
  styleUrls: ['./recuperar.component.css'],
})
export class RecuperarComponent {
  paso: number = 1;
  correo: string = '';
  codigo: string = '';
  nuevaContrasena: string = '';
  mensaje: string = '';
  error: string = '';

  constructor(private authService: AuthService) { }

  enviarCodigo(): void {
    Swal.fire({
      title: 'Enviando código',
      text: 'Por favor espera un momento...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    this.authService.enviarCodigo(this.correo).subscribe({
      next: (res) => {
        Swal.close();
        this.mensaje = res.mensaje || 'Código enviado a tu correo';
        this.error = '';
        this.paso = 2;

        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: this.mensaje,
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      },
      error: (err) => {
        Swal.close();
        this.error = err.error?.error || 'Error al enviar código';

      },
    });
  }

  cambiarContrasena(): void {
    this.authService
      .cambiarContraseña(this.correo, this.codigo, this.nuevaContrasena)
      .subscribe({
        next: (res) => {
          this.mensaje = res.mensaje || 'Contraseña actualizada correctamente';
          this.error = '';
          this.paso = 3;
        },
        error: (err) => {
          this.error = err.error?.error || 'Error al cambiar contraseña';
        },
      });
  }
  mostrarPassword = false;
}
